import React from 'react';
import SimpleGoogleMap from './SimpleGoogleMap';

interface EventLocationViewerProps {
  latitude: number;
  longitude: number;
  title: string;
  address: string;
  className?: string;
  height?: string;
  showFullAddress?: boolean;
}

const EventLocationViewer: React.FC<EventLocationViewerProps> = ({
  latitude,
  longitude,
  title,
  address,
  className = '',
  height = 'h-64',
  showFullAddress = true
}) => {
  return (
    <div className={`space-y-3 ${className}`}>
      {/* We're hiding the default header since we're using a custom one in SearchDiscovery */}

      {/* Address Display */}
      {showFullAddress && address && (
        <div className="bg-gray-50 rounded-lg p-3">
          <p className="font-lucy-rose text-sm text-gray-700">
            <strong>Address:</strong> {address}
          </p>
          <p className="font-lucy-rose text-xs text-gray-500 mt-1">
            <strong>Coordinates:</strong> {latitude.toFixed(6)}, {longitude.toFixed(6)}
          </p>
        </div>
      )}

      {/* Map Container - Google Maps */}
      <SimpleGoogleMap
        latitude={latitude}
        longitude={longitude}
        title={title}
        address={address}
        className=""
        height={height}
        showFullAddress={false}
        enableSearch={false}
        openInfoByDefault={true}
      />

      {/* Map Instructions */}
      <div className="text-xs text-gray-500 font-lucy-rose text-center">
        Click markers for info • Use controls to explore • Click buttons for directions
      </div>
    </div>
  );
};

export default EventLocationViewer;